// import external dependencies

import "jquery";

// Import Slick
import "slick-carousel";

// Import everything from autoload
import "./autoload/_foundation.js";
import AOS from "aos";
import "./modules/parallax";
import "./modules/jquery.selectBox";

jQuery(document).ready(($) => {

    $(".hero-rotation__slider").slick({
        infinite: true,
        slidesToShow: 1,
        fade: false,
        autoplay: true,
        autoplaySpeed: 3000,
        arrows: false,
        dots: false,
        vertical: true,
    });

    $('[data-parallax="scroll"]').parallax();

    function transparentHeader() {

        let heroLogo = $('.hero__logo'),
            header = $('.header');

        if ($(window).width() > 1023) {
            if (parseInt($(window).scrollTop()) > heroLogo.offset().top) {

                header.removeClass('transparent');

            } else {
                header.addClass('transparent');
            }

        } else {
            header.removeClass('transparent');
        }
    }

    transparentHeader();

    $(window).on('scroll', function () {
        transparentHeader();
    });

    $(window).on('resize', function () {
        transparentHeader();
    });

    let bgContentHeading = $('.bg-content.oral .bg-content__top');

    bgContentHeading.waypoint({
        handler: function (direction) {

            if (direction === 'down') {

                $(this.element).removeClass('hidden');

            } else {
                $(this.element).addClass('hidden');
            }
        },
        offset: '70%',
    });

    AOS.init({
        disable: 'mobile',
    });

    var header = $('.bg-content__bg-green');
    var range = 500;

    $(window).on('scroll', function () {

        var scrollTop = $(this).scrollTop(),
            height = header.outerHeight(),
            offset = height / 2,
            calc = 0.8 - (scrollTop - offset + 300) / range;

        header.css({ 'opacity': calc });

        if (calc > '0.8') {
            header.css({ 'opacity': 0.8 });
        } else if ( calc < '0' ) {
            header.css({ 'opacity': 0 });
        }

    });

    $('.widget_categories select, .widget_archive select').selectBox({
        mobile: true,
        keepInViewport: false,
    });

});


// WEBPACK FOOTER //
// ./scripts/main.js